import React, { useEffect } from "react";
import Tickets from "./tickets";
import { useDispatch, useSelector } from "react-redux";
import { getPurchaseTickets } from "../../redux/slices/purchaseTicketsSlice";

const TicketNoList = ({ tickets, isFrozen }) => {
  // Group tickets into rows
  const groupedTickets = [
    tickets.filter((_, index) => index === 0), // First row (ticket number 0)
    tickets.filter((_, index) => index >= 1 && index <= 3), // Second row (ticket numbers 1 to 2)
    tickets.filter((_, index) => index >= 4 && index <= 6), // Third row (ticket numbers 3 to 5)
    tickets.filter((_, index) => index >= 7 && index <= 9), // Fourth row (ticket numbers 6 to 9)
  ];

  const dispatch = useDispatch();

  // Select the purchased tickets from Redux store
  const { purchaseTicket } = useSelector((state) => state.purchase);

  // Retrieve the user ID from local storage
  const userId = localStorage.getItem("userID");

  // Fetch purchased tickets when the user ID changes
  useEffect(() => {
    if (userId) {
      dispatch(getPurchaseTickets(userId));
    }
  }, [userId, dispatch]);

  return (
    <div style={{ position: "relative" }}>
      {/* Disable pointer events and reduce opacity if tickets are frozen */}
      <div
        style={{
          pointerEvents: isFrozen ? "none" : "auto",
          opacity: isFrozen ? 0.6 : 1,
        }}
      >
        {/* Render grouped tickets row-wise */}
        {groupedTickets.map((row, rowIndex) => (
          <div
            key={rowIndex}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {row.map((ticket) => (
              <div className=" relative" key={ticket.id}>
                <Tickets
                  ticket_id={ticket.id}
                  ticketQuantity={ticket.ticket_quantity}
                  ticketNo={ticket.ticket_number}
                  maxQuantity={ticket.max_ticket_quantity}
                  price={ticket.ticket_price}
                  purchaseTicket={purchaseTicket}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TicketNoList;

// import React from "react";
// import ProgressBar from "../progressBar"

// const TicketNoList = ({ tickets, isFrozen }) => {
//   return (
//     <div style={{ position: "relative" }}>
//       <div
//         style={{
//           pointerEvents: isFrozen ? "none" : "auto",
//           opacity: isFrozen ? 0.6 : 1,
//         }}
//       >
//         {tickets.map((ticket) => (
//           <div className="m-[6px] relative" key={ticket.id}>
//             <ProgressBar
//               ticket_id={ticket.id}
//               ticketQuantity={ticket.ticket_quantity}
//               ticketNo={ticket.ticket_number}
//               maxQuantity={ticket.max_ticket_quantity}
//               price={ticket.ticket_price}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default TicketNoList;
